module.exports = __webpack_public_path__ + "img/arrow-left-2.aa1dac12.svg";